import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { BasicInput } from '@dev/ee-components';

import styled from 'styled-components';

import { debounce } from '@/services/tools/debounce';
import { useGetAutomatedInfo } from '@/components/CampaignCreator/SettingsAndTracking/hooks/useGetAutomatedInfo';
import { ModifyCampaignMap } from '@/store/campaignCreator/actions';

const InputWrapper = styled.div`
    margin-top: 16px;
`;

export const LinkOption = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { triggerData } = useGetAutomatedInfo();
    const [linkTrigger, setLinkTrigger] = useState(triggerData);

    const changeInputHandle = (e): void => {
        setLinkTrigger(e.target.value);
        debounce(() => {
            const modifyMap = new Map<string, any>();
            modifyMap.set('TriggerOptions.TriggeredBy.Data', e.target.value);
            dispatch(ModifyCampaignMap(modifyMap));
        });
    };

    return (
        <InputWrapper>
            <BasicInput
                id="autoresponder-from-dropdown"
                label={t('specificlinkcontains')}
                type="input"
                value={linkTrigger}
                fullWidth
                onChange={changeInputHandle}
            />
        </InputWrapper>
    );
};
